import { setSettings } from '../actions';
import { identityPayload, createReducer, forAction } from '../utils';

const initialState = {};

export default createReducer(
  [forAction(setSettings, identityPayload)],
  initialState,
);
